<script setup lang="ts">
import WidgetRecordAction from '@components/widget/WidgetRecordAction.vue'

const { records, isSelected } = defineProps<{
  records: any[],
  isSelected: Function,
}>()

const emit = defineEmits(['set', 'getRecords', 'select', 'unselect', 'isSelected'])
</script>

<template>
  <VFragment>
    <VTable v-if="records?.length">
      <thead>
        <tr>
          <th>Номер</th>
          <th>Наименование</th>
          <th>Группа</th>
          <th>Срок службы</th>
          <th>Инвентаризационный номер</th>
          <th>СИЗ</th>
          <th>Вид СИЗ</th>
          <th>Размер</th>
          <th>Сертиф.</th>
          <th class="text-center mw-100">
            Действие
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="record in records"
          :key="record.Uuid || record.Bundle.Uuid"
        >
          <td>
            <RouterLink
              :to="{ name: 'logistic', params: { uuid: record.Bundle.Uuid }, query: { tab: 'preview' } }"
              target="_blank"
            >
              {{ record.Number }}
            </RouterLink>
          </td>
          <td>{{ record.Name }}</td>
          <td>{{ record.Group.Name || '-' }}</td>
          <td>{{ record.ServiceLife }}</td>
          <td>
            <VIcon
              v-if="record.RequireInventoryNumber"
              icon="mdi-check"
            />
            <div v-else>
              -
            </div>
          </td>
          <td>
            <VIcon
              v-if="record.PersonalProtection"
              icon="mdi-check"
            />
            <div v-else>
              -
            </div>
          </td>
          <td>
            <RouterLink
              :to="{ name: 'equip-type', params: { uuid: record.TypeUuid }, query: { tab: 'preview' } }"
              target="_blank"
            >
              {{ record.Type }}
            </RouterLink>
          </td>
          <td>
            <RouterLink
              :to="{ name: 'anthropometry', params: { uuid: record.SizeUuid }, query: { tab: 'preview' } }"
              target="_blank"
            >
              {{ record.Size }}
            </RouterLink>
          </td>
          <td>
            <RouterLink
              :to="{ name: 'equip-cert', params: { uuid: record.CertUuid }, query: { tab: 'preview' } }"
              target="_blank"
            >
              <VIcon
                v-if="record.CertExists"
                icon="mdi-check"
              />
              <div v-else>
                -
              </div>
            </RouterLink>
          </td>
          <td class="text-center">
            <WidgetRecordAction
              :selected="isSelected(record.Uuid || record.Bundle.Uuid)"
              @set="emit('select', record)"
              @delete="emit('unselect', record)"
            />
          </td>
        </tr>
      </tbody>
    </VTable>

    <VListItem v-else>
      Нет данных.
    </VListItem>
  </VFragment>
</template>

<style lang="scss" scoped>
.form-component-bottom {
  display: flex;
  align-items: center;
}

.form-component-bottom__pagination {
  flex-grow: 1;
}
</style>
